import { observer } from 'mobx-react-lite';
import React from 'react';
import { unrefSection } from '../model_helpers';
import { CommonPanelProps } from '../sidebar/panel_props';
import { getGlobalConceptsStore } from '../styleguide/concept_store';
import { ImageryPanel } from '../styleguide/imagery_panel';

export const DesignImagesPanel = observer(function _DesignImagesPanel({
  session,
  navigation,
  library,
  toastQueue,
  analytics,
  selection,
}: CommonPanelProps) {
  const conceptsStore = getGlobalConceptsStore();
  const concept = conceptsStore.activeConcept;

  const sel = selection.get();
  const sref = sel.section;
  if (sref == null) {
    return null;
  }

  const section = unrefSection(sref, session.project) ?? null;

  return (
    <ImageryPanel
      session={session}
      navigation={navigation}
      library={library}
      undo={session.undo}
      toastQueue={toastQueue}
      analytics={analytics}
      concept={concept}
      section={section}
    />
  );
});
